import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-export-modal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.scss'],
})
export class ExportModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { endpoint: string; reqObj: any },
    private dialogRef: MatDialogRef<ExportModalComponent>,
    private genericService: GenericService,
    private toastService: ToastrService,
  ) {}

  exportType: 'excel' | 'csv' = 'csv';
  downloading = false;

  exportIsCSV(): boolean {
    return this.exportType == 'csv';
  }

  close(): void {
    this.dialogRef.close();
  }

  export(): void {
    this.downloading = true;
    this.data.reqObj.ExportType = this.exportType;
    this.genericService.download(this.data.endpoint, this.data.reqObj).subscribe(
      () => {
        this.downloading = false;
        this.dialogRef.close();
      },
      (error) => {
        this.toastService.error('', error, { timeOut: 2000 });
        this.dialogRef.close();
      },
    );
  }
}

export function openExportDialog(dialog: MatDialog, data: { endpoint: string; reqObj: any }): Observable<any> {
  const config = new MatDialogConfig();
  config.data = data;
  config.minHeight = '300px';
  config.minWidth = '520px';
  const dialogRef = dialog.open(ExportModalComponent, config);
  return dialogRef.afterClosed();
}
